/* HelloSpicy — scripts extraits de sections/hs-badge-produit.liquid (audit A23 : sortis du HTML pour l'alléger et les mettre en cache). */
(function () {
      var source = document.querySelector('[data-hs-badge-source]');
      if (!source) return;

      function poser() {
        var cible = document.querySelector('.product-media-container');
        if (!cible || !source.parentNode) return false;
        cible.insertAdjacentHTML('afterbegin', source.innerHTML);
        source.remove();
        return true;
      }

      /* Tentative immédiate : le script s'exécute pendant l'analyse du document,
         juste après la galerie, donc avant le premier rendu — pas de
         clignotement. Le repli ne sert que si cette section a été déplacée
         avant `main` dans le gabarit. */
      if (!poser()) {
        document.addEventListener('DOMContentLoaded', poser, { once: true });
      }
    })();
